"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const optimizationType = {
  noise: "Noise",
  voltageRange: "VoltageRange",
  power: "Power",
  recommendedSpecific: "RecommendedSpecificComponents",
  allowedSpecific: "AllowedSpecificComponents"
};
const Limits = {
  RSMALL_LOAD_LIMIT: 50,
  RSMALL_COMP_LIMIT: 1,
  RBIG_COMP_LIMIT: 100000000,
  CSMALL_COMP_LIMIT: 0,
  CSMALL_COMP_1PF: 1e-12,
  CBIG_COMP_LIMIT: 1e-5,
  INFINITY: 1e66,
  NEGINFINITY: -1e60
};
const resistorTolerance = {
  ideal: "ideal",
  oneTenth: "0.1%",
  fiveTenths: "0.5%",
  one: "1%",
  five: "5%"
};
const capacitorTolerance = {
  ideal: "ideal",
  one: "1%",
  five: "5%",
  ten: "10%",
  twenty: "20%"
};
const opAmpStatus = {
  allowed: "allowed",
  notAllowed: "not allowed",
  recommended: "recommended",
  notRecommended: "not recommended"
};
const biasPreferenceOptions = {
  positive: "positive",
  negative: "negative"
};
const specialOpAmps = [{
  partNumber: 'AD8099',
  minGain: 20,
  pole1: 6e8,
  pole2: 2e9,
  zero: 2e9,
  compPin: true
}, {
  partNumber: 'AD8021',
  minGain: 10,
  pole1: 1e10,
  pole2: 4.4e8,
  zero: 4.5e8,
  compPin: true
}, {
  partNumber: 'AD829',
  minGain: 20,
  pole1: 1e8,
  pole2: 2e8,
  zero: 2e8,
  compPin: true
}, {
  partNumber: 'ADA4895-1',
  minGain: 10,
  pole1: 1e9,
  pole2: 1e9,
  zero: 1e9,
  compPin: false
}, {
  partNumber: 'ADA4895-2',
  minGain: 10,
  pole1: 3e8,
  pole2: 2e9,
  zero: 1e9,
  compPin: false
}, {
  partNumber: 'ADA4637-1',
  minGain: 5,
  pole1: 1e9,
  pole2: 1e9,
  zero: 1e9,
  compPin: false
}, {
  partNumber: 'AD8067',
  minGain: 8,
  pole1: 1.5e8,
  pole2: 2e8,
  zero: 1.5e8,
  compPin: false
}, {
  partNumber: 'AD8397',
  minGain: 2,
  pole1: 1.5e8,
  pole2: 2.3e8,
  zero: 2.3e8,
  compPin: false
}];
const filterType = {
  lowPass: "lowPass",
  highPass: "highPass",
  bandPass: "bandPass",
  bandStop: "bandStop",
  gain: "gain",
  notch: "notch"
};
const pdStages = {
  oneStage: 1,
  twoStage: 2
};
const pdCircuits = {
  oneStagePositive: 'oneStagePositive',
  oneStageNegative: 'oneStageNegative'
};
const toggleUnits = {
  vv: "V/V",
  va: "V/A",
  db: "dB"
};
const circuitComponents = {
  Cf: "Cf",
  Rf: "Rf",
  Rf2: "Rf2",
  Rg2: "Rg2",
  Cfilter: "Cfilter",
  Rfilter: "Rfilter",
  D1: "D1",
  OpAmp1: "OpAmp1",
  OpAmp2: "OpAmp2"
};
var _default = exports.default = {
  optimizationType,
  Limits,
  resistorTolerance,
  capacitorTolerance,
  opAmpStatus,
  biasPreferenceOptions,
  specialOpAmps,
  filterType,
  pdStages,
  pdCircuits,
  toggleUnits,
  circuitComponents
};